import Api from 'core/services/api'
import { exportReportRequest } from './reports.types'

const path = '/v1/products'

/**
 * Solicita a geração de um relatório com os produtos do catálogo.
 * @param product_ids
 */
export const exportReport = (data: exportReportRequest | null) => {
  return Api.request({
    url: `${path}/export`,
    data,
    method: 'post',
  })
}
